module.exports = __webpack_public_path__ + "static/media/jazz_temp.87aea343.jpg";